import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const n8n = defineConnector({
  identifier: "n8n",
  name: "n8n",
  tagLine: "Workflow automation platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([{ name: "X-N8N-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your n8n API key",
      items: [
        {
          kind: "markdown",
          content: "In n8n, go to **Settings > API** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your n8n details",
      items: [
        {
          kind: "baseUrl",
          label: "n8n instance URL",
          required: true,
          placeholder: "https://your-instance.app.n8n.cloud",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your n8n instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/workflows?limit=1`,
  },
});
